import { AuthUser, HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useUserProfileApi } from './use-user-profile-api';

export function useUserEditMutationApi() {
  return useBaseMutation<AuthUser, AuthUser>(
    {
      url: '/customer-management/um/users/profile',
      method: HttpMethod.put,
    },

    {
      onSuccess: () => {
        baseQueryClient.invalidateQueries([useUserProfileApi.name]);
      },
    }
  );
}
